export default __webpack_public_path__ + "static/media/IMG_4530-min.7ad28956.JPG";